<div
  class="sp-width__full sp-height__full sp-page__with-navbar"
  [ngClass]="getNavbarClass()">
  <app-navbar
    class="sp-hidden__before-lg"
    [current_nav_item]="current_nav_item"
    [navbar_status]="navbar_status"
    (status_change)="onNavbarStatusChange($event)"></app-navbar>
  <div class="sp-position__relative">
    <app-toolbar
      [current_nav_item]="current_nav_item"
      [width_class]="getToolbarWidthClass()"></app-toolbar>
    <app-loading *ngIf="is_list_running"></app-loading>
    <div
      *ngIf="!is_list_running"
      class="sp-page__with-absolute-toolbar sp-grid__gap sp-padding__x2">
      <div class="sp-row__space sp-wrap sp-margin__bottom">
        <div class="sp-row__align sp-wrap">
          <button
            (click)="onBackClick()"
            mat-icon-button
            class="sp-icon__button sp-icon__button-accent sp-margin__right"
            [matTooltip]="'GENERAL.BACK_CTA' | translate">
            <mat-icon>arrow_back</mat-icon>
          </button>
          <h2 class="sp-color__accent sp-margin__bottom">{{ cluster_code }} - {{ cluster_name }}</h2>
        </div>
        <button
          (click)="onAddClick()"
          mat-icon-button
          class="sp-icon__button sp-icon__button-accent sp-margin__left"
          [matTooltip]="'CLUSTER.ADD_VERSION_TOOLTIP' | translate">
          <mat-icon>add</mat-icon>
        </button>
      </div>

      <div
        *ngIf="current_or_future_clusters.length"
        class="sp-width__full sp-overflow__x-scroll sp-position__relative sp-card sp-table__sticky-header__no-summary">
        <table
          mat-table
          [dataSource]="current_or_future_clusters"
          class="sp-width__full">
          <ng-container matColumnDef="valid_from">
            <th
              mat-header-cell
              *matHeaderCellDef>
              <span class="sp-text__ellipsized">
                {{ 'CLUSTER.VALID_FROM_COLUMN_LABEL' | translate }}
              </span>
            </th>
            <td
              mat-cell
              *matCellDef="let cluster">
              <span class="sp-color__primary sp-text__ellipsized">
                {{ cluster.valid_from | date : 'shortDate' }}
              </span>
            </td>
          </ng-container>

          <ng-container matColumnDef="valid_to">
            <th
              mat-header-cell
              *matHeaderCellDef>
              <span class="sp-text__ellipsized">
                {{ 'CLUSTER.VALID_TO_COLUMN_LABEL' | translate }}
              </span>
            </th>
            <td
              mat-cell
              *matCellDef="let cluster">
              <span class="sp-color__primary sp-text__ellipsized">
                {{ cluster.valid_to | date : 'shortDate' }}
              </span>
            </td>
          </ng-container>

          <ng-container matColumnDef="actions">
            <th
              mat-header-cell
              *matHeaderCellDef>
              <span class="sp-text__ellipsized">
                {{ 'CLUSTER.ACTIONS_COLUMN_LABEL' | translate }}
              </span>
            </th>
            <td
              mat-cell
              *matCellDef="let cluster">
              <div class="sp-row__align">
                <button
                  (click)="onEditClick(cluster)"
                  mat-icon-button
                  class="sp-icon__button sp-icon__button-accent sp-margin__left"
                  [matTooltip]="'CLUSTER.EDIT_VERSION_TOOLTIP' | translate">
                  <mat-icon> edit </mat-icon>
                </button>
              </div>
            </td>
          </ng-container>

          <tr
            mat-header-row
            *matHeaderRowDef="['valid_from', 'valid_to', 'actions']; sticky: true"></tr>
          <tr
            mat-row
            *matRowDef="let row; columns: ['valid_from', 'valid_to', 'actions']"></tr>
        </table>
      </div>

      <div
        *ngIf="is_tan_max_running"
        class="sp-width__full sp-margin__top">
        <h3 class="sp-color__accent sp-margin__bottom">{{ 'CLUSTER.ACTIVE_TAN_MAX_LABEL' | translate }}</h3>
        <div class="sp-width__full sp-card sp-padding__horiz sp-padding__vert">
          <div
            *ngFor="let skeleton_row of tan_max_skeleton_rows"
            class="sp-row__align sp-row__space sp-padding__vert">
            <app-loading
              class="sp-width__half sp-height__small"
              [card_radius]="'sp-border-radius__xs'"></app-loading>
            <app-loading
              class="sp-width__half sp-height__small"
              [card_radius]="'sp-border-radius__xs'"></app-loading>
          </div>
        </div>
      </div>

      <div *ngIf="!is_tan_max_running && active_tan_max" class="sp-width__full sp-margin__top">
        <h3 class="sp-color__accent sp-margin__bottom">{{ 'CLUSTER.ACTIVE_TAN_MAX_LABEL' | translate }}</h3>
        <div class="sp-width__full sp-overflow__x-scroll sp-position__relative sp-card sp-table__sticky-header__no-summary">
          <table mat-table [dataSource]="active_tan_max.configurations" class="sp-width__full">
            <ng-container matColumnDef="steps_number">
              <th mat-header-cell *matHeaderCellDef>
                <span class="sp-text__ellipsized">{{ 'CLUSTER.STEPS_NUMBER_COLUMN_LABEL' | translate }}</span>
              </th>
              <td mat-cell *matCellDef="let configuration">
                <span class="sp-color__primary sp-text__ellipsized sp-text__bold">{{ configuration.steps_number }}</span>
              </td>
            </ng-container>
            <ng-container matColumnDef="value">
              <th mat-header-cell *matHeaderCellDef>
                <span class="sp-text__ellipsized">{{ 'CLUSTER.MAX_TAN_COLUMN_LABEL' | translate }}</span>
              </th>
              <td mat-cell *matCellDef="let configuration">
                <span class="sp-color__primary sp-text__ellipsized">{{ configuration.value / 100 }}%</span>
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="['steps_number', 'value']; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: ['steps_number', 'value']"></tr>
          </table>
        </div>
      </div>

      <div *ngIf="!is_tan_max_running && future_tan_max.length" class="sp-width__full sp-margin__top">
        <h3 class="sp-color__accent sp-margin__bottom">{{ 'CLUSTER.FUTURE_TAN_MAX_LABEL' | translate }}</h3>
        <div *ngFor="let tan_max of future_tan_max" class="sp-width__full sp-margin__bottom">
          <div class="sp-row__space sp-row__align sp-margin__bottom">
            <h4 class="sp-color__accent">{{ tan_max.valid_from | date : 'shortDate' }}</h4>
            <button
              (click)="onDeleteTanMaxClick(tan_max)"
              mat-icon-button
              class="sp-icon__button sp-icon__button-warn sp-margin__left"
              [matTooltip]="'CLUSTER.DELETE_TAN_MAX_TOOLTIP' | translate">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
          <div class="sp-width__full sp-overflow__x-scroll sp-position__relative sp-card sp-table__sticky-header__no-summary">
            <table mat-table [dataSource]="tan_max.configurations" class="sp-width__full">
              <ng-container matColumnDef="steps_number">
                <th mat-header-cell *matHeaderCellDef>
                  <span class="sp-text__ellipsized">{{ 'CLUSTER.STEPS_NUMBER_COLUMN_LABEL' | translate }}</span>
                </th>
                <td mat-cell *matCellDef="let configuration">
                  <span class="sp-color__primary sp-text__ellipsized sp-text__bold">{{ configuration.steps_number }}</span>
                </td>
              </ng-container>
              <ng-container matColumnDef="value">
                <th mat-header-cell *matHeaderCellDef>
                  <span class="sp-text__ellipsized">{{ 'CLUSTER.MAX_TAN_COLUMN_LABEL' | translate }}</span>
                </th>
                <td mat-cell *matCellDef="let configuration">
                  <span class="sp-color__primary sp-text__ellipsized">{{ configuration.value / 100 }}%</span>
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="['steps_number', 'value']; sticky: true"></tr>
              <tr mat-row *matRowDef="let row; columns: ['steps_number', 'value']"></tr>
            </table>
          </div>
        </div>
      </div>

      <mat-accordion *ngIf="past_clusters.length">
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>{{ 'CLUSTER.PAST_VERSIONS_LABEL' | translate }}</mat-panel-title>
          </mat-expansion-panel-header>
          <div
            class="sp-width__full sp-overflow__x-scroll sp-position__relative sp-card sp-table__sticky-header__no-summary sp-margin__top">
            <table
              mat-table
              [dataSource]="past_clusters"
              class="sp-width__full">
              <ng-container matColumnDef="valid_from">
                <th
                  mat-header-cell
                  *matHeaderCellDef>
                  <span class="sp-text__ellipsized">
                    {{ 'CLUSTER.VALID_FROM_COLUMN_LABEL' | translate }}
                  </span>
                </th>
                <td
                  mat-cell
                  *matCellDef="let cluster">
                  <span class="sp-color__primary sp-text__ellipsized">
                    {{ cluster.valid_from | date : 'shortDate' }}
                  </span>
                </td>
              </ng-container>

              <ng-container matColumnDef="valid_to">
                <th
                  mat-header-cell
                  *matHeaderCellDef>
                  <span class="sp-text__ellipsized">
                    {{ 'CLUSTER.VALID_TO_COLUMN_LABEL' | translate }}
                  </span>
                </th>
                <td
                  mat-cell
                  *matCellDef="let cluster">
                  <span class="sp-color__primary sp-text__ellipsized">
                    {{ cluster.valid_to | date : 'shortDate' }}
                  </span>
                </td>
              </ng-container>

              <tr
                mat-header-row
                *matHeaderRowDef="['valid_from', 'valid_to']; sticky: true"></tr>
              <tr
                mat-row
                *matRowDef="let row; columns: ['valid_from', 'valid_to']"></tr>
            </table>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </div>
</div>
